<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Edit Feedback

        <span
          v-if="!account.has_pro_features"
          class="tag is-success"
          >PRO</span
        >
        <router-link
          v-if="!account.has_pro_features"
          :to="{ name: 'Upgrade' }"
          class="tag is-info"
          >Unlock Now</router-link
        >
      </p>
    </header>
      <div class="modal-card-body">
        <div class="is-medium">
          <p>Change the feedback for the Wall of Love only. The original feedback is kept as is.</p>

          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input class="input" type="text" v-model="feedback.name">
            </div>
          </div>
          <div class="field">
            <label class="label">Feedback</label>
            <div class="control">
              <textarea class="textarea" type="text" v-model="feedback.reason"></textarea>
            </div>
          </div>
        </div>
        <p class="mt-4 notification is-warning">Make sure feedback and name don't violate personal data laws like GDPR!</p>
      </div>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <button class="button" @click="$emit('close')">Cancel</button>
        <button class="button is-primary" :disabled="isBlocked || !subscribed" @click="saveAndAdd">Save & Add</button>
      </footer>
  </div>
</template>

<script>
import {isFeedbackBlocked} from "../lib/commons"
import atomic from "atomicjs"
import { mapState } from "vuex"
export default {
  name: "WoLFeedbackEdit",
  props: [
    "feedback",
    "wolid"
  ],
  data: function () {
    return {
    };
  },
  mounted: function () {

  },
  methods: {
    saveAndAdd: async function() {
      var self = this;
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          let loadingComponent = this.$buefy.loading.open({
            container: null
          })
          let url = self.apiHost + "walloflove/" + self.wolid + "/feedback?a=edit"
          return atomic(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: {
              "wol_id": self.wolid,
              "feedback_id": self.feedback.id,
              "feedback": self.feedback.reason,
              "name": self.feedback.name,
            }
          })
            .then(function (response) {
              self.$parent.$parent.selectedFeedback.push(self.feedback)
              self.$parent.$parent.selectableFeedback.splice(self.$parent.$parent.selectableFeedback.findIndex(v => v.id === self.feedback.id), 1)
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Feedback added to Wall of Love`,
                type: 'is-success'
              })
              self.$emit('close')
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              let msg = `Oops! Something went wrong but it wasn't you. It was us and the team was already notified. Please try again later.`
              if(error.status === 403) {
                msg =`Access Denied: You don't have rights to access this Wall of Love.`
              }
              self.$buefy.toast.open({
                duration: 5000,
                message: msg,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            })
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    }
  },
  computed: {
    isBlocked() {
      return isFeedbackBlocked(this.feedback)
    },
    subscribed() {
      return this.account.subscribed;
    },
    ...mapState(["user", "account"]),
  },
};
</script>

<style scoped lang="scss">

</style>